import React, { useEffect, useMemo, useState } from "react";
import { Nav } from "react-bootstrap";
import { Toaster } from "react-hot-toast";
import { Icon } from "@iconify/react";
import { useButtonTableStyle } from "../utils/useButtonTableStyle";
import { EssHolidaysLeavesTab } from "../components/EssHolidaysLeavesTab";
import { EssMyAttendanceTab } from "../components/EssMyAttendanceTab";
import { EssMyRequestsTab } from "../components/EssMyRequestsTab";
import "./HrmsPage.css";

const TAB_DEFS = [
  {
    id: "holidays-leaves",
    label: "Holidays / Leaves",
    icon: "solar:calendar-linear",
    can: () => true,
  },
  {
    id: "my-attendance",
    label: "My attendance",
    icon: "solar:login-2-linear",
    can: () => true,
  },
  {
    id: "my-requests",
    label: "My requests",
    icon: "solar:clipboard-check-linear",
    can: () => true,
  },
];

function EmployeeSelfService() {
  const { cardClass, buttonTableStyle } = useButtonTableStyle();

  const [tab, setTab] = useState("holidays-leaves");

  const [permTick, setPermTick] = useState(0);

  useEffect(() => {
    const fn = () => setPermTick((n) => n + 1);
    window.addEventListener("permissionsUpdated", fn);
    window.addEventListener("erpAuthUpdated", fn);
    return () => {
      window.removeEventListener("permissionsUpdated", fn);
      window.removeEventListener("erpAuthUpdated", fn);
    };
  }, []);

  const visibleTabs = useMemo(
    () => TAB_DEFS.filter((t) => t.can()),
    [permTick],
  );

  useEffect(() => {
    if (!visibleTabs.length) return;
    if (!visibleTabs.some((t) => t.id === tab)) {
      setTab(visibleTabs[0].id);
    }
  }, [visibleTabs, tab]);

  const renderTab = () => {
    switch (tab) {
      case "holidays-leaves":
        return <EssHolidaysLeavesTab />;
      case "my-attendance":
        return <EssMyAttendanceTab />;
      case "my-requests":
        return <EssMyRequestsTab />;
      default:
        return null;
    }
  };

  if (!visibleTabs.length) {
    return (
      <div className="body-wrapper">
        <Toaster position="top-center" />
        <div className="container-fluid py-5 text-center text-muted">
          You do not have access to Employee Self-Service.
        </div>
      </div>
    );
  }

  return (
    <div className="body-wrapper">
      <Toaster position="top-center" />
      <div className="container-fluid">
        <div
          className={`card w-100 position-relative overflow-hidden hrms-page-card ${cardClass} ${
            buttonTableStyle === "square" ? "rounded-0" : ""
          }`}
        >
          <div className="hrms-page-header px-4 py-3 border-bottom d-flex flex-wrap justify-content-between align-items-center gap-2 bg-white text-start">
            <div className="d-flex align-items-center gap-2">
              <h4 className="card-title mb-0">Employee Activity Calendar</h4>
            </div>
          </div>
          <div className="card-body p-0 d-flex flex-column">
            <div className="hrms-page-tabs-wrap border-bottom px-4 bg-white">
              <Nav
                variant="tabs"
                className="hrms-module-tabs flex-nowrap overflow-auto justify-content-start"
              >
                {visibleTabs.map((t) => (
                  <Nav.Item key={t.id}>
                    <Nav.Link
                      as="button"
                      type="button"
                      className={`d-flex align-items-center gap-1 text-nowrap small hrms-tab-link ${
                        tab === t.id ? "active" : ""
                      }`}
                      onClick={() => setTab(t.id)}
                    >
                      <Icon icon={t.icon} width={15} height={15} />
                      {t.label}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </div>
            <div className="hrms-page-body flex-grow-1 p-4 bg-white text-start">
              {renderTab()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmployeeSelfService;
